import { useEffect, useState } from "react";
import "./AtivarVagaoModal.css";

export default function AtivarVagaoModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function handleOk() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao ativar.");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="ptatv-bg" onClick={onClose}>
      <div className="ptatv-box" role="dialog" aria-modal="true" aria-label="Ativar vagão" onClick={(e) => e.stopPropagation()}>
        <header className="ptatv-head">
          <h3 className="ptatv-title">Ativar</h3>
          <button className="ptatv-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>
            x
          </button>
        </header>

        <div className="ptatv-body">
          Deseja <strong>ativar</strong> "{titulo || "este vagão"}"?
          {err ? <div className="ptatv-err">{err}</div> : null}
        </div>

        <footer className="ptatv-foot">
          <button className="ptatv-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ptatv-btn ptatv-btn-ok" type="button" onClick={handleOk} disabled={busy}>
            {busy ? "Ativando..." : "Ativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}
